<template>
  <el-select
    v-model="vendorId"
    filterable
    remote
    clearable
    :placeholder="placeholder"
    :remote-method="remoteMethod"
    :loading="loading">
    <el-option
      v-for="item in options"
      :key="item.vendorId"
      :label="item.vendorName"
      :value="item.vendorId">
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: 'EntRemoteSelect',
  props: {
    value: { required: true },
    placeholder: { type: String, default: '请输入商家名称' }
  },
  data() {
    return { loading: false, options: [], config: { pageNum: 1, pageSize: 20, appraisalOpenFlag: 1, statusList: [0] }}
  },
  computed: {
    vendorId: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    remoteMethod(vendorName) {
      if (vendorName) {
        this.loading = true
        this.$store.dispatch('account/getvendors', {
          payload: { ...this.config, vendorName },
          success: (res) => {
            this.loading = false
            this.options = res.data.records
          },
          fail: () => {
            this.loading = false
          }
        })
      }
    }
  }
}
</script>
